'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var RuleQuickController = function RuleQuickController($scope, conditionsAndActionsService, saveRuleService, elementServiceProvider, StrategyCondition, StrategyConstants, strategyClosureActionService, strategyAllocationAuthAvailActionService, levelSecondaryService, commentsService, rulesService, userSecureService, featureToggleService, validation, statementBoxService, commonUiConstants, xtFormValidationService) {
  var NEW_ALERT_RULE = 'New Quick Alert Rule';
  var NEW_RULE = 'New Quick Rule';
  var OPERAND_DATA_OVER_THRESHOLD_ERROR_MESSAGE = '';
  var selectedLevelForMarket = 'ServiceClassPOS';
  var marketPrivilege = userSecureService.hasAuthorization('market-analysis', 'write');
  var flightPrivilege = userSecureService.hasAuthorization('flight-analysis', 'write');
  var formulaeMaster = [];
  function defaultSecondaryStrategies() {
    var actionService = $scope.selectedTemplate.id === StrategyConstants.ALLOCATION_AUTH_AVAIL.BASIS ? strategyAllocationAuthAvailActionService : strategyClosureActionService;
    $scope.templateStrategy = {
      commonConditions: [new StrategyCondition({})],
      basis: $scope.selectedTemplate.id,
      actionList: actionService.getActionList()
    };
    $scope.$broadcast('ruleQuick:resetLevelStrategy');
  }
  function fetchFormulaeMaster() {
    var formulae = [];
    var fieldPrefix = 'custom';
    var formulaNameList = [];
    _.forEach($scope.conditionCategories, function (category) {
      _.filter(category, function () {
        _.forEach(category.criteria, function (criteria) {
          if (criteria.field.split('.')[0] === fieldPrefix && formulaNameList.indexOf(criteria.field.split('.')[1]) == -1) {
            var formula = {};
            formulaNameList.push(criteria.field.split('.')[1]);
            formula.name = criteria.field.split('.')[1];
            formula.formula = criteria.formula;
            formulae.push(formula);
          }
        });
      });
    });
    return formulae;
  }
  function fetchRuleFormulae(formulaeMaster) {
    var formulae = [];
    var fieldPrefix = 'custom';
    _.forEach($scope.rule.primaryCriteria, function (criteria) {
      if (criteria.field.split('.')[0] === fieldPrefix) {
        _.forEach(formulaeMaster, function (formulaObj) {
          if (formulaObj.name === criteria.field.split('.')[1]) {
            formulae.push(formulaObj);
          }
        });
      }
    });
    return formulae;
  }
  function fetchStrategyFormulae(formulaeMaster) {
    var formulae = [];
    var fieldPrefix = 'custom';
    var strategyToSave = $scope.isTemplateRuleStructure() ? $scope.templateStrategy : $scope.levelStrategy;
    _.forEach(strategyToSave.groups, function (group) {
      _.forEach(group.conditions, function (condition) {
        if (condition.field.split('.')[0] === fieldPrefix) {
          _.forEach(formulaeMaster, function (formulaObj) {
            if (formulaObj.name === condition.field.split('.')[1]) {
              formulae.push(formulaObj);
            }
          });
        }
      });
    });
    return formulae;
  }
  function fillLevelStrategy() {
    _.forEach($scope.rule.strategies, function (strategy) {
      _.forEach(strategy.statements, function (statement) {
        $scope.levelStrategy.groups.push({
          level: statement.level,
          conditions: statement.parsedConditions,
          actions: statement.parsedActions
        });
      });
      //there's only one technical strategy connected to quick rule
      $scope.levelStrategy.technicalId = strategy.technicalId;
    });
  }
  function fillSecondaryStrategies() {
    $scope.templateStrategy = {
      commonConditions: $scope.rule.strategies[0].parsedCommonConditions,
      basis: $scope.rule.strategies[0].basis,
      actionList: $scope.rule.strategies[0].actionList,
      technicalId: $scope.rule.strategiesRef[0].technicalId
    };
    $scope.$broadcast('ruleQuick:resetLevelStrategy');
  }
  function determinePanelTitle() {
    if ($scope.rule.old) {
      return $scope.rule.name;
    }
    return $scope.rule.type === StrategyConstants.PANEL_TYPE.ALERTS ? NEW_ALERT_RULE : NEW_RULE;
  }
  function secureMarketFlightPrivilege() {
    var levels = [];
    if (marketPrivilege && !flightPrivilege) {
      _.filter(conditionsAndActionsService.getLevels($scope.activeEntityType), function (level) {
        if (level.domain === 'ServiceClassPOS' || level.domain === 'MarketDemandClassGroup') {
          return levels.push(level);
        }
      });
    } else if (!marketPrivilege && flightPrivilege) {
      _.filter(conditionsAndActionsService.getLevels($scope.activeEntityType), function (level) {
        if (level.domain !== 'ServiceClassPOS' && level.domain !== 'MarketDemandClassGroup') {
          return levels.push(level);
        }
      });
    } else {
      levels = conditionsAndActionsService.getLevels($scope.activeEntityType);
    }
    if (featureToggleService.isDisabled('SPOS')) {
      _.forEach(levels, function (level) {
        if (_.includes(level.label, 'POS')) {
          level.label = _.trimEnd(_.replace(level.label, 'POS', ''));
        }
      });
    }
    return levels;
  }
  function resetSelectedConditionsAndActions() {
    $scope.primaryCriteriaElementService.resetCollection();
    activeElementService.clearSelection();
    activeElementService = $scope.primaryCriteriaElementService;
    activeElementService.selectFirstElement();
  }
  $scope.levelStrategy = {
    basis: 'custom',
    groups: []
  };
  $scope.startDateIsAfterEndDate = 'Start date must be earlier or equal to end date';
  $scope.endDateIsBeforeStartDate = 'End date must be later or equal to start date';
  $scope.invalidDate = 'The value must be a valid date';
  $scope.ruleStatusOptions = StrategyConstants.DROP_DOWN_DATA.RULE_STATUS;
  $scope.ruleStructureType = _.clone(StrategyConstants.RuleStructureType);
  $scope.levelOptions = secureMarketFlightPrivilege();
  $scope.templateOptions = conditionsAndActionsService.getTemplates();
  $scope.isSummaryVisible = false;
  $scope.summaryMessage = StrategyConstants.ERROR_MESSAGES.MULTIPLE;
  $scope.PANEL_TYPE = StrategyConstants.PANEL_TYPE;
  $scope.commentsOpened = false;
  $scope.ruleKeyForComments = 'technicalId';
  $scope.RULE_NAME_PATTERN = commonUiConstants.ALPHA_NUMERIC_WITH_SOME_EXTRA_CHARS;
  $scope.ruleNameMsg = 'Rule name contains invalid characters. Only alphanumeric characters and -, _, <, >, = are allowed.';
  var defaultStrategyDomainLevel = conditionsAndActionsService.getDefaultStrategyDomainLevel();
  function getLevelConfig(domain) {
    return _.find($scope.levelOptions, {
      domain: domain
    });
  }
  function setIsFlowTypeSelectable(primaryLevel) {
    var isFlowTypeSelectable = getLevelConfig(primaryLevel.domain).isFlowTypeSelectable;
    if (isFlowTypeSelectable) {
      primaryLevel.isFlowTypeSelectable = isFlowTypeSelectable;
    }
  }

  //set default when secure flight or market
  if (marketPrivilege && !flightPrivilege) {
    $scope.selectedLevel = getLevelConfig(selectedLevelForMarket);
  } else if ($scope.rule.primaryCriteriaLevel) {
    var primaryLevel = $scope.rule.primaryCriteriaLevel;
    setIsFlowTypeSelectable(primaryLevel);
    $scope.selectedLevel = primaryLevel;
  } else {
    $scope.selectedLevel = getLevelConfig(defaultStrategyDomainLevel);
  }
  if (featureToggleService.isEnabled('MAPPED_MODE')) {
    setDefaultFlowType($scope.selectedLevel);
  }
  $scope.ruleStructure = rulesService.isQuickRuleWithTemplate($scope.rule) ? $scope.ruleStructureType.TEMPLATE : $scope.ruleStructureType.LEVEL;
  $scope.selectedTemplate = !_.isNil($scope.rule.strategies) ? _.find($scope.templateOptions, {
    id: $scope.rule.strategies[0].basis
  }) : $scope.templateOptions[0];
  $scope.panelTitle = determinePanelTitle();
  $scope.dialogMessageType = null;
  $scope.switchFlowType = function () {
    resetSelectedConditionsAndActions();
    $scope.updateConditionCategories($scope.selectedLevel.domain);
    if ($scope.ruleStructure === $scope.ruleStructureType.TEMPLATE) {
      defaultSecondaryStrategies();
    }
    $scope.$broadcast('ruleQuick:flowTypeChange');
  };
  $scope.cancelFlowTypeChange = function () {
    $scope.rule.flowType = StrategyConstants.FlowType.find(function (val) {
      return val !== $scope.rule.flowType;
    });
  };
  function handleFlowTypeChange(newType, oldType) {
    if (newType !== oldType) {
      if (hasSomeConditionsOrActionsProvided()) {
        $scope.dialogMessageType = StrategyConstants.CONFIRMATION_MESSAGES.FLOW_TYPE.CONDITIONS_FILLED;
        $scope.showConfirmationDialog();
      } else {
        $scope.switchFlowType();
      }
    }
  }
  if (featureToggleService.isEnabled('MAPPED_MODE')) {
    $scope.$watch('rule.flowType', handleFlowTypeChange);
  }
  if ($scope.rule.old && $scope.rule.strategies) {
    if (rulesService.isQuickRuleWithTemplate($scope.rule)) {
      fillSecondaryStrategies();
    } else {
      fillLevelStrategy();
    }
  } else {
    defaultSecondaryStrategies();
  }
  $scope.primaryCriteriaElementService = elementServiceProvider.getInstance({
    preAddingNewElementHook: function preAddingNewElementHook() {
      $scope.setActiveElementService($scope.primaryCriteriaElementService);
      return true;
    },
    createNewElement: function createNewElement() {
      return new StrategyCondition({});
    },
    getCollection: function getCollection() {
      return $scope.rule && $scope.rule.primaryCriteria;
    },
    getSelectedRowType: function getSelectedRowType() {
      return StrategyConstants.CONDITION;
    },
    isDuplicable: function isDuplicable() {
      return true;
    },
    createCopyOf: function createCopyOf(element) {
      if (element instanceof StrategyCondition) {
        return element.createCopy();
      }
      return null;
    }
  });

  // used by the accordion to add a new condition to primary or link criteria
  var activeElementService = $scope.primaryCriteriaElementService;
  $scope.setActiveElementService = function (elementService) {
    if (activeElementService !== elementService) {
      activeElementService.clearSelection();
    }
    activeElementService = elementService;
  };
  $scope.switchToLevelSecondaryService = function () {
    if (activeElementService === $scope.primaryCriteriaElementService) {
      activeElementService.clearSelection();
    }
    activeElementService = levelSecondaryService;
  };
  $scope.isRowSelectedPrimaryCriteria = $scope.primaryCriteriaElementService.isElementSelected;
  $scope.ruleKeyForComments = 'technicalId';
  $scope.conditionsAccordionSelect = function (conditionCategory, conditionCriteria) {
    activeElementService.insertElement(new StrategyCondition({
      metaCategory: conditionCriteria.metaCategory,
      category: conditionCategory.categoryName,
      criterion: conditionCriteria.criteriaName,
      field: conditionCriteria.field,
      operator: conditionCriteria.operators[0].operator,
      precision: conditionCriteria.operators[0].precision,
      isFieldValueRequired: !_.isUndefined(conditionCategory.isFieldValueRequired) ? conditionCategory.isFieldValueRequired : true
    }));
  };
  $scope.updateConditionCategories = function (domain) {
    var condition = conditionsAndActionsService.getConditionByDomain(domain, $scope.activeEntityType, $scope.rule.flowType);
    $scope.conditionCategories = condition.categories;
  };
  $scope.changeSelectedRowPrimaryCriteria = function (elem) {
    $scope.primaryCriteriaElementService.selectElement(elem);
    $scope.updateConditionCategories($scope.selectedLevel.domain);
    $scope.updateActionCategories($scope.selectedLevel.domain);
    $scope.setActiveElementService($scope.primaryCriteriaElementService);
  };
  function setDefaultFlowType(level) {
    if (level.isFlowTypeSelectable) {
      $scope.rule.flowType = $scope.rule.flowType || StrategyConstants.DefaultFlowType["default"];
    } else {
      $scope.rule.flowType = undefined;
    }
  }
  $scope.onPrimaryCriteriaSelectedLevelChanged = function (newValue, oldValue) {
    if (newValue.domain !== oldValue.domain) {
      resetSelectedConditionsAndActions();
      if (featureToggleService.isEnabled('MAPPED_MODE')) {
        setDefaultFlowType(newValue);
      }
    }
    $scope.updateConditionCategories($scope.selectedLevel.domain);
    $scope.updateActionCategories($scope.selectedLevel.domain);
  };
  $scope.updateActionCategories = function (domain) {
    var action = conditionsAndActionsService.getActionByDomain(domain, $scope.activeEntityType);
    $scope.actionCategories = action.categories;
  };
  $scope.onRuleStructureChanged = function (oldValue, newValue) {
    $scope.setActiveElementService($scope.primaryCriteriaElementService);
    if (oldValue !== newValue) {
      defaultSecondaryStrategies();
    }
    if ($scope.ruleStructure === StrategyConstants.RuleStructureType.TEMPLATE) {
      if ($scope.selectedLevel.domain !== defaultStrategyDomainLevel) {
        $scope.selectedLevel = {
          domain: defaultStrategyDomainLevel
        };
      }
    }
  };
  $scope.onSelectedTemplateChange = function () {
    defaultSecondaryStrategies();
  };
  function closePanel() {
    $scope.hideConfirmationDialog();
    $scope.xtForm.reset();
    $scope.hideSummary();
    $scope.closePanelHandler();
    $scope.commentsExist = false;
    $scope.commentsOpened = false;
    $scope.$emit('rules:toggleReadOnlyPanelVisibility');
  }
  $scope.saveRule = function () {
    var ruleName = $scope.rule.name,
      ruleNote = $scope.rule.notes;
    formulaeMaster = fetchFormulaeMaster();
    $scope.rule.ruleFormulae = fetchRuleFormulae(formulaeMaster);
    $scope.rule.notes = undefined;
    $scope.rule.primaryCriteriaLevel = $scope.selectedLevel;
    $scope.rule.strategies = [];
    $scope.rule.appliedStrategies = [];
    var strategyToSave = $scope.isTemplateRuleStructure() ? $scope.templateStrategy : $scope.levelStrategy;
    var strategyFormulae = fetchStrategyFormulae(formulaeMaster);
    if (strategyFormulae != null && strategyFormulae.length > 0) {
      strategyToSave.formulae = strategyFormulae;
    }
    saveRuleService.saveRule($scope.rule, strategyToSave).then(function (response) {
      if (ruleNote) {
        ruleNote = ruleNote.substring(0, 500);
        commentsService.save({
          technicalId: response.technicalId
        }, $scope.ruleKeyForComments, ruleNote, $scope.rule.primaryCriteriaLevel.domain);
      }
      $scope.$emit('rules:dataAndSelectionChanged', {
        name: ruleName,
        technicalId: response.technicalId
      });
      closePanel();
      toastr.success('Successfully saved changes.');
    }, function (reason) {
      $scope.isSummaryVisible = true;
      var reasonStr = reason.data ? ' (' + reason.data.message + ')' : '';
      $scope.summaryMessage = StrategyConstants.ERROR_MESSAGES.SAVING + reasonStr;
      saveRuleService.repopulateStrategy(strategyToSave);
    });
  };

  /**
   * Returns true if all actions are empty in at least one of the groups
   * For template-based rule returns true if all actions in template are empty
   * @returns {boolean}
   */
  function hasGroupWithAllActionsEmpty() {
    if ($scope.ruleStructure === $scope.ruleStructureType.TEMPLATE) {
      return _.every($scope.templateStrategy.actionList, validation.isCriteriaEmpty);
    }
    return _.find($scope.levelStrategy.groups, function (group) {
      return _.every(group.actions, validation.isCriteriaEmpty);
    });
  }

  /**
   * Returns true if any of the conditions in secondary criteria is not filled fully
   */
  function hasIncompleteSecondaryConditions() {
    if ($scope.ruleStructure === $scope.ruleStructureType.LEVEL) {
      return _.find($scope.levelStrategy.groups, function (group) {
        return _.find(group.conditions, validation.isCriteriaIncomplete);
      });
    } else {
      return _.find($scope.templateStrategy.commonConditions, validation.isCriteriaIncomplete);
    }
  }

  /**
   * Validate if location and date criteria are selected in primary or secondary criteria
   * @returns {*|Boolean}
   */
  function validateLocationAndDateCriteria() {
    var criteria = $scope.rule.primaryCriteria;
    return validation.isLocationAndDateSelected(criteria) || validateSecondary(validation.isLocationAndDateSelected);
  }

  /**
   * Validates secondary criteria by the passed function
   * @param validateFunction
   * @returns {*}
   */
  function validateSecondary(validateFunction) {
    if ($scope.ruleStructure === $scope.ruleStructureType.LEVEL) {
      return _.find($scope.levelStrategy.groups, function (group) {
        return validateFunction(group.conditions);
      });
    } else {
      return validateFunction($scope.templateStrategy.commonConditions);
    }
  }
  function hasOperandDataQuantityOverThreshold() {
    var criteriaOverThreshold = validation.filterCriteriaOverThreshold($scope.rule.primaryCriteria);
    if ($scope.ruleStructure === $scope.ruleStructureType.LEVEL) {
      _.forEach($scope.levelStrategy.groups, function (group) {
        criteriaOverThreshold = criteriaOverThreshold.concat(validation.filterCriteriaOverThreshold(group.conditions));
      });
    } else {
      criteriaOverThreshold = criteriaOverThreshold.concat(validation.filterCriteriaOverThreshold($scope.templateStrategy.commonConditions));
    }
    if (criteriaOverThreshold.length > 0) {
      var criteriaNames = validation.getCriteriaNamesForMessage(criteriaOverThreshold);
      OPERAND_DATA_OVER_THRESHOLD_ERROR_MESSAGE = StrategyConstants.ERROR_MESSAGES.OPERAND_DATA_OVER_THRESHOLD + criteriaNames;
      return true;
    }
    return false;
  }

  /**
   * Returns true if any of the actions is not filled fully
   */
  function hasIncompleteActions() {
    if ($scope.ruleStructure === $scope.ruleStructureType.LEVEL) {
      return _.find($scope.levelStrategy.groups, function (group) {
        return _.find(group.actions, validation.isCriteriaIncomplete);
      });
    }
    return false;
  }

  /**
   * Returns true if all conditions rows (in primary and secondary sections) are empty
   */
  function conditionsNotProvided() {
    if (!_.every($scope.rule.primaryCriteria, validation.isCriteriaEmpty)) {
      return false;
    } else if ($scope.ruleStructure === $scope.ruleStructureType.TEMPLATE) {
      return _.every($scope.templateStrategy.commonConditions, validation.isCriteriaEmpty);
    }
    return _.every($scope.levelStrategy.groups, function (group) {
      return _.every(group.conditions, validation.isCriteriaEmpty);
    });
  }
  function hasSomeConditionsOrActionsProvided() {
    return !conditionsNotProvided() || !actionsNotProvided();
  }
  function actionsNotProvided() {
    if ($scope.ruleStructure === $scope.ruleStructureType.TEMPLATE) {
      return _.every($scope.templateStrategy.actionList, validation.isCriteriaEmpty);
    }
    return _.every($scope.levelStrategy.groups, function (group) {
      return _.every(group.actions, validation.isCriteriaEmpty);
    });
  }
  function prepareSummaryMessage(errorType) {
    $scope.isSummaryVisible = true;
    $scope.summaryMessage = errorType;
  }
  $scope.isTemplateRuleStructure = function () {
    return $scope.ruleStructure === $scope.ruleStructureType.TEMPLATE;
  };
  $scope.isClassClosureTemplateSelected = function () {
    if (_.isUndefined($scope.selectedTemplate)) {
      return;
    }
    return $scope.selectedTemplate.id === StrategyConstants.CLASS_CLOSURE.BASIS;
  };
  $scope.isAllocationAuthAvailTemplateSelected = function () {
    if (_.isUndefined($scope.selectedTemplate)) {
      return false;
    }
    return $scope.selectedTemplate.id === StrategyConstants.ALLOCATION_AUTH_AVAIL.BASIS;
  };
  $scope.focusError = function () {
    if ($scope.focusErrorMsg) {
      $scope.focusErrorMsg();
    }
  };
  $scope.saveButtonHandler = function () {
    $scope.summaryMessage = null;
    $scope.isSummaryVisible = false;
    var duplicated;
    var errorLst = [];
    if ($scope.isAllocationAuthAvailTemplateSelected()) {
      errorLst = strategyAllocationAuthAvailActionService.validateActions($scope.templateStrategy.actionList);
    }
    if ($scope.rule.isValid()) {
      if (hasGroupWithAllActionsEmpty()) {
        prepareSummaryMessage(StrategyConstants.ERROR_MESSAGES.MISSING_ACTIONS);
        $scope.focusError();
        return;
      } else if (validation.hasIncompletePrimaryConditions($scope.rule)) {
        prepareSummaryMessage(StrategyConstants.ERROR_MESSAGES.INCOMPLETE_PC);
        $scope.focusError();
        return;
      } else if (hasIncompleteSecondaryConditions()) {
        prepareSummaryMessage(StrategyConstants.ERROR_MESSAGES.INCOMPLETE_SC);
        $scope.focusError();
        return;
      } else if (hasIncompleteActions()) {
        prepareSummaryMessage(StrategyConstants.ERROR_MESSAGES.INCOMPLETE_SA);
        $scope.focusError();
        return;
      } else if (!_.isEmpty(errorLst)) {
        prepareSummaryMessage(errorLst);
        $scope.focusError();
        return;
      } else if (hasOperandDataQuantityOverThreshold()) {
        prepareSummaryMessage(OPERAND_DATA_OVER_THRESHOLD_ERROR_MESSAGE);
        return;
      } else if (conditionsNotProvided()) {
        $scope.dialogMessageType = StrategyConstants.CONFIRMATION_MESSAGES.CONDITIONS_EMPTY;
        $scope.showConfirmationDialog();
        return;
      } else if ((duplicated = validation.collectDuplicatedConditions($scope.rule.primaryCriteria)) && duplicated.length) {
        prepareSummaryMessage(StrategyConstants.ERROR_MESSAGES.PRIMARY_DUPLICATES + duplicated.join(', '));
        $scope.focusError();
        return;
      } else if ((duplicated = validation.collectDuplicatedGroupConditions($scope.levelStrategy.groups)) && duplicated.length) {
        prepareSummaryMessage(StrategyConstants.ERROR_MESSAGES.SECONDARY_DUPLICATES + duplicated.join(', '));
        $scope.focusError();
        return;
      } else if (validateLocationAndDateCriteria()) {
        $scope.saveRule();
        return;
      } else {
        $scope.dialogMessageType = StrategyConstants.CONFIRMATION_MESSAGES.DATE_LOCATION_EMPTY;
        $scope.showConfirmationDialog();
        return;
      }
    } else {
      if (!$scope.rule.isValidEffectiveDate()) {
        prepareSummaryMessage(StrategyConstants.ERROR_MESSAGES.EFFECTIVE_DATE);
        $scope.focusError();
        return;
      }
    }
    $scope.xtForm.submit();
    if ($scope.xtForm.form.$invalid && $scope.xtForm.form.$error && !_.isEmpty($scope.xtForm.form.$error)) {
      $scope.isSummaryVisible = true;
      $scope.summaryMessage = xtFormValidationService.getSummaryMessage($scope.xtForm.form.$error);
      $scope.focusError();
    }
  };
  $scope.cancelButtonHandler = function () {
    closePanel();
  };
  $scope.isLevelRuleStructure = function () {
    return $scope.ruleStructure === $scope.ruleStructureType.LEVEL;
  };
  $scope.hideSummary = function () {
    $scope.isSummaryVisible = false;
  };
  $scope.toggleComments = function () {
    $scope.commentsOpened = !$scope.commentsOpened;
  };
  $scope.onCommentsUpdated = function (comments) {
    $scope.commentsExist = comments.length;
  };
  $scope.onCommentsClose = function () {
    $scope.commentsOpened = false;
  };
  $scope.isStatementEmpty = function (group) {
    var strategy = $scope.isTemplateRuleStructure() ? $scope.templateStrategy : $scope.levelStrategy;
    strategy = _.cloneDeep(strategy);
    if (group) {
      strategy.groups = [group];
    }
    return statementBoxService.isStatementEmpty($scope.rule, strategy);
  };
  $scope.isTemplateAvailable = featureToggleService.isDisabled('SERVICE_CLASS_CONTROL');
};
RuleQuickController.$inject = ['$scope', 'ConditionsAndActionsService', 'SaveRuleService', 'ElementServiceProvider', 'StrategyConditionFactory', 'StrategyConstants', 'StrategyClosureActionService', 'StrategyAllocationAuthAvailActionService', 'LevelSecondaryService', 'CommentsService', 'RulesService', 'UserSecureService', 'FeatureToggleService', 'CriteriaValidateAndFilterService', 'StatementBoxService', 'CommonUiConstants', 'XtFormValidationService'];
module.exports = RuleQuickController;